
import { RevIllustration } from '@ds/components/Illustration'

import { paymentGroupIcon } from '../../methods'

export default {
  components: {
    RevIllustration,
  },

  props: {
    groupId: {
      type: String,
      required: true,
    },
  },

  computed: {
    icon() {
      return paymentGroupIcon(this.groupId)
    },
  },
}
